<template>
  <div>
    <v-card>
      <div class="pt-2">
        <v-card flat>
          <v-row class="d-flex justify-space-between padding-bottom">
            <div>
              <v-btn
                  depressed
                  color="primary"
                  v-on:click="back()">
                返回
              </v-btn>
            </div>
          </v-row>
        </v-card>
      </div>
    </v-card>
    <v-form v-model="data">
      <v-card class="ma-2" elevation="0">
        <v-card-title>基础信息</v-card-title>
        <v-card-text>
          <v-row no-gutters justify="space-around">
            <v-col cols="12" sm="3" style="text-align: left">
              <label>记录编号:</label><label>{{ data.id }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>事项编号:</label><label>{{ data.itemCode }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>所属科目:</label><label>{{ data.subjectName }}</label>
            </v-col>
          </v-row>
          <v-row no-gutters justify="space-around" class="mt-3">
            <v-col cols="12" sm="3" style="text-align: left">
              <label>业务事项:</label><label>{{ data.itemName }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>自维/外委:</label><label>{{ data.type == 1 ? '自维' : '外委' }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>维保内容:</label><label>{{ data.wbContent }}</label>
            </v-col>
          </v-row>
          <v-row no-gutters justify="space-around" class="mt-3">
            <v-col cols="12" sm="3" style="text-align: left">
              <label>所属年份:</label><label>{{ data.year }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>所属月份:</label><label>{{ data.month }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>状态:</label><label>{{ data.statusName }}</label>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="ma-2" elevation="0" v-if="data.orderDetail">
        <v-card-title>实施信息</v-card-title>
        <v-card-text>
          <v-row no-gutters align="center" justify="space-around">
            <v-col cols="12" sm="3" style="text-align: left">
              <label>完成描述:</label><label>{{ data.orderDetail.completeDescription }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>特别事项记录:</label><label>{{ data.orderDetail.remarks }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>使用地点:</label><label>{{ data.orderDetail.usePlace }}</label>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>维保图片:</label>
            </v-col>
          </v-row>
          <template v-if="wbPics">
            <v-row>
              <v-col
                  v-for="(item,index) in wbPics"
                  :key="index"
                  class="d-flex child-flex"
                  cols="3">
                <img :src="item"
                     aspect-ratio="1"
                     class="grey lighten-2"
                     preview="0"
                     width="139"
                     height="139"
                     style="object-fit: cover">
              </v-col>
            </v-row>
          </template>
          <v-row no-gutters align="center" justify="space-around" class="mt-3">
            <v-col cols="12" sm="3" style="text-align: left">
              <label>处理人:</label><label>{{ data.orderDetail.handleBy }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>派单时间:</label><label>{{ data.orderDetail.createTime }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>处理时间:</label><label>{{ data.orderDetail.handleTime }}</label>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="ma-2" elevation="0" v-if="data.orderRecheck">
        <v-card-title>复检记录</v-card-title>
        <v-card-text>
          <v-simple-table dense class="mb-2">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center" width="100">复检描述</th>
                <th class="text-center" width="100">复检人</th>
                <th class="text-center" width="100">复检时间</th>
                <th class="text-center" width="200">复检图片</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,i) in data.orderRecheck" :key="i">
                <td class="text-center">{{ item.description }}</td>
                <td class="text-center">{{ item.createBy }}</td>
                <td class="text-center">{{ item.createTime }}</td>
                <td class="text-center">
                  <template v-if="item.picUrls">
                    <v-col
                        v-for="(url,index) in item.picUrls"
                        :key="index"
                        class="d-flex child-flex"
                        cols="3">
                      <img :src="url"
                           aspect-ratio="1"
                           class="grey lighten-2"
                           preview="1"
                           width="139"
                           height="139"
                           style="object-fit: cover">
                    </v-col>
                  </template>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <v-card class="ma-2" elevation="0" v-if="data.orderDetail&&data.type==2">
        <v-card-title>评价信息</v-card-title>
        <v-card-text>
          <v-row no-gutters align="center" justify="space-around">
            <v-col cols="12" sm="3" style="text-align: left">
              <label>反应速度:</label><label>{{ data.orderDetail.speedScore }}星</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>专业水平:</label><label>{{ data.orderDetail.specialtyScore }}星</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>服务态度:</label><label>{{ data.orderDetail.serviceScore }}星</label>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="ma-2" elevation="0" v-if="data.orderOperations">
        <v-card-title>操作记录</v-card-title>
        <v-card-text>
          <v-simple-table dense class="mb-2">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center" width="100">时间</th>
                <th class="text-center" width="100">处理状态</th>
                <th class="text-center" width="100">操作员</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,i) in data.orderOperations" :key="i">
                <td class="text-center">{{ item.createTime }}</td>
                <td class="text-center">{{ item.statusName }}</td>
                <td class="text-center">{{ item.createBy }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import {default as OrderDetailApi} from "@/api/pd/wborder/OrderDetailApi.js";

export default {
  props: {
    id: [Number, String],
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      loading: false,
      data: {},
      wbPics: null
    };
  },
  mounted() {
    this.getDataFromApi();

  },
  methods: {
    back() {
      this.$emit("back")
    },
    getDataFromApi() {
      this.loading = true;
      let me = this;
      OrderDetailApi.detailWbOrder({
        orderId: this.id
      }).then(resp => {
        OrderDetailApi.handleResponse(resp, me, function (data) {
          me.loading = false;
          me.data = data;
          if (data.orderDetail && data.orderDetail.pictures) {
            me.wbPics = data.orderDetail.pictures.split(",");
            me.$previewRefresh();
          }
        }, function () {
          me.loading = false;
        })
      }).catch(error => {
        OrderDetailApi.handleNetworkError(error, me, function () {
          me.loading = false;
        })
      })
    },
  }
};
</script>
<style scoped>
.container {
  padding: 0;
}

.row {
  margin: 0;
}

.padding-bottom {
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}

.padding-top {
  padding-top: 30px;
}

.margin-right {
  margin-right: 12px;
}

.v-application p {
  margin-bottom: 0;
}
</style>